export default __webpack_public_path__ + "static/media/other.b326e7ee.svg";